import type { FaireProductEntity } from "../../entity_types/product";

export const p_dbxjm7aewk: FaireProductEntity = {
  token: "p_dbxjm7aewk",
  type: "product",
  name: "Acupressure Mat Set - Wellness Recovery",
  brandToken: "b_a03hpip0sg",
  brandName: "WTHN",
  imageUrl:
    "https://cdn.faire.com/fastly/1e94709f33c2e263d109ea8db7909095033bfab99da257ca55daaff7deeb9569.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32198f6fa05b9fbd69ea8fa65edfc3b6797765c16f27c8ff0fef6f8736a55c93.webp",
    "https://cdn.faire.com/fastly/63424dda8426d24b6a77f64075921aa4e2b0922c57a969219747dc2ff7d886f8.webp",
    "https://cdn.faire.com/fastly/1bb87cce3f37f0c7d75ab1a3e95e3c1508bd679fd99a043040029d2eeba5e4e5.webp",
    "https://cdn.faire.com/fastly/ebe5c48a60da6d8a2ef2041bd6c7e0099845d32ec93977449a9e4c32b725f037.webp",
    "https://cdn.faire.com/fastly/9e26ef8ed1920689493c11821b94b5d35d522253285e655bbe13fdcec4517f8a.jpeg",
  ],
  priceDollars: 48,
  description:
    'If you suffer from chronic pain, tech neck, headaches, body stiffness or stress, the acupressure mat is for you. Leveraging the traditional principles of acupressure, the WTHN acumat has gentle stimulators that activate points across the body to foster deep relaxation. Made with linen and filled with coconut fiber for your most luxurious acupressure session yet.\n\nThe WTHN Acupressure Mat Set includes:\n\nCoconut Fiber and Linen Acupressure Mat - Dimensions 16" x 9" x 9"\nMemory Foam and Linen Acupressure Pillow\nOn-the-go Linen Carrying Case\nHow-To Guide \nAlso featured in Vogue\n\nVisit WTHNsider to learn more about the Acupressure Mat and how to use it.\n\n *This product is FSA/HSA eligible.\n',
  tags: [],
  msrpDollars: 88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:45.189Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
